module.exports = __webpack_public_path__ + "static/img/RE.fc64d192.svg";